import React, { PropTypes } from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import ListSubjectItem from './list-subject-item'

const ListSemSubject = ({ items }) => (
  <Table condensed>
    <thead>
      <tr>
        <th colSpan="11"><kbd>Year: {items.getIn(['meta', 'year'])} Sem: {items.getIn(['meta', 'sem'])}</kbd></th>
      </tr>
      <tr>
        <th width="15%">Subject Code</th>
        <th>Subject Description</th>
        <th width="6%" className="text-right">Lec Units</th>
        <th width="6%" className="text-right">Lab Units</th>
        <th width="6%" className="text-right">Total Units</th>
        <th width="15%">Pre / CoRequisites</th>
        <th width="3%" className="text-right">MT</th>
        <th width="3%" className="text-right">FT</th>
        <th width="3%" className="text-right">FG</th>
        <th width="3%" className="text-right">RE</th>
      </tr>
    </thead>
    <tbody>
      { items && items.get('subjects').map((subject) => (
        <ListSubjectItem
          key={subject.get('id')}
          subject={subject}
        />
      ))}
    </tbody>
    <tfoot>
      <tr>
        <th colSpan="2" className="text-right">Sub Total:</th>
        <th className="text-right">{acc.formatNumber(items.getIn(['meta', 'total_lec']), 1)}</th>
        <th className="text-right">{acc.formatNumber(items.getIn(['meta', 'total_lab']), 1)}</th>
        <th className="text-right">{acc.formatNumber(items.getIn(['meta', 'total']), 1)}</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </tfoot>
  </Table>
)

ListSemSubject.propTypes = {
  items: PropTypes.object,
}

export default ListSemSubject



// WEBPACK FOOTER //
// ./src/containers/Curriculum/list-sem-subject.js